import React, { useState } from 'react';
import PageHeader from '../components/PageHeader';

// Netlify Forms expects a urlencoded POST to any path on the site, carrying a
// `form-name` that matches the hidden form registered in public/index.html.
const encode = data =>
  Object.keys(data)
    .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
    .join('&');

function ContactPage() {
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [botField, setBotField] = useState('');
  const [status, setStatus] = useState('idle');

  const update = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const submit = e => {
    e.preventDefault();
    setStatus('sending');

    fetch('/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: encode({
        'form-name': 'contact',
        'bot-field': botField,
        ...form,
      }),
    })
      .then(res => {
        if (!res.ok) {
          throw new Error(`Form submission failed: ${res.status}`);
        }
        setStatus('sent');
        setForm({ name: '', email: '', message: '' });
      })
      .catch(() => {
        setStatus('error');
      });
  };

  return (
    <>
      <PageHeader
        eyebrow="Get Involved"
        title="Join the Campaign"
        lead="Volunteer, host a yard sign, or send Ron a note. Every voice in Big Flats matters."
      />

      <section className="section contact contact--page">
        <div className="container">
          <div className="contact__grid">
            <div className="contact__info">
              <div className="contact__row">
                <div>
                  <strong>Email</strong>
                  <a href="mailto:rnjohanson@yahoo.com">rnjohanson@yahoo.com</a>
                </div>
              </div>
              <div className="contact__row">
                <div>
                  <strong>Phone</strong>
                  <a href="tel:+16077421425">(607)-742-1425</a>
                </div>
              </div>
              <div className="contact__row">
                <div>
                  <strong>Mail</strong>
                  Ron Johanson for County Legislature<br />
                  656 County Road 64<br />
                   Elmira, NY 14903
                </div>
              </div>
              <div className="contact__row">
                <div>
                  <strong>On LinkedIn</strong>
                  <a
                    href="https://www.linkedin.com/in/ronald-johanson-3ab62a10/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    linkedin.com/in/ronald-johanson
                  </a>
                </div>
              </div>
              <div className="contact__row">
                <div>
                  <strong>On Facebook</strong>
                  Find updates in the Friends of Big Flats community.
                </div>
              </div>
            </div>

            <form
              className="form"
              name="contact"
              method="POST"
              data-netlify="true"
              data-netlify-honeypot="bot-field"
              onSubmit={submit}
            >
              <input type="hidden" name="form-name" value="contact" />
              {/* Honeypot. aria-hidden + tabIndex keep it away from screen
                  readers and keyboard users, so only bots fill it in --
                  Netlify silently discards submissions where it is set. */}
              <p className="form__botfield" aria-hidden="true">
                <label>
                  Leave this field empty
                  <input
                    name="bot-field"
                    tabIndex={-1}
                    autoComplete="off"
                    value={botField}
                    onChange={e => setBotField(e.target.value)}
                  />
                </label>
              </p>
              <div className="form__row">
                <label htmlFor="name">Name</label>
                <input
                  id="name"
                  name="name"
                  type="text"
                  value={form.name}
                  onChange={update}
                  required
                />
              </div>
              <div className="form__row">
                <label htmlFor="email">Email</label>
                <input
                  id="email"
                  name="email"
                  type="email"
                  value={form.email}
                  onChange={update}
                  required
                />
              </div>
              <div className="form__row">
                <label htmlFor="message">Message</label>
                <textarea
                  id="message"
                  name="message"
                  value={form.message}
                  onChange={update}
                  required
                />
              </div>
              <button
                type="submit"
                className="btn btn--primary"
                disabled={status === 'sending'}
              >
                {status === 'sending' ? 'Sending…' : 'Send Message'}
              </button>
              {status === 'sent' && (
                <div className="form__success" role="status">
                  Thanks &mdash; your message is on its way to Ron. He reads
                  every one.
                </div>
              )}
              {status === 'error' && (
                <div className="form__error" role="alert">
                  Something went wrong and your message didn&rsquo;t send.
                  Please call{' '}
                  <a href="tel:+16077421425">(607)-742-1425</a> or email{' '}
                  <a href="mailto:rnjohanson@yahoo.com">
                    campaign@ronjohanson.com
                  </a>{' '}
                  instead.
                </div>
              )}
            </form>
          </div>
        </div>
      </section>
    </>
  );
}

export default ContactPage;
